module.exports = __webpack_public_path__ + "static/anjas-b19875606b12f0f2faeed267bbb29c25.png";